import * as React from "react";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import ApplicantsAppointmentPresentationModel, {
  TApplicantsAppointmentPresentationModel
} from "../../../presenter/applicants/model/ApplicantsAppointmentPresentationModel";
import ApplicantsAppointmentForm from "./ApplicantsAppointmentForm";

export interface State {}

export interface UpdateApplicantAppointmentFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  rowData: TApplicantsAppointmentPresentationModel;
  codebooks: any;
}

class UpdateApplicantAppointmentForm extends React.Component<
  UpdateApplicantAppointmentFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler, rowData } = this.props;
    registerFormSubmitEventHandler((e) => {
      e.preventDefault();
      let updateApplicantAppointmentData = null;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          updateApplicantAppointmentData = { ...rowData, ...values };
        }
      });
      return updateApplicantAppointmentData;
    });
  }

  render() {
    const { translate, rowData, codebooks } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <ApplicantsAppointmentForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        rowData={rowData}
        codebooks={codebooks}
        readOnly={rowData.readOnly}
      />
    );
  }
}

export default UpdateApplicantAppointmentForm;
